// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991px) {
  .sidebar-backdrop {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    border: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1030;
  }

  .row-offcanvas .sidebar-offcanvas {
    z-index: 1040;
  }

  /* Keep the closed off-canvas panel from widening the mobile document. */
  .row-offcanvas:not(.active) .sidebar-offcanvas {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/layout-mobile.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,+BAA+B;IAC/B,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,wEAAwE;EACxE;IACE,aAAa;EACf;AACF","sourcesContent":["@media (max-width: 991px) {\n  .sidebar-backdrop {\n    position: fixed;\n    top: 50px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 0;\n    background: rgba(0, 0, 0, 0.35);\n    z-index: 1030;\n  }\n\n  .row-offcanvas .sidebar-offcanvas {\n    z-index: 1040;\n  }\n\n  /* Keep the closed off-canvas panel from widening the mobile document. */\n  .row-offcanvas:not(.active) .sidebar-offcanvas {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
